import { z } from "zod";
import { TRAIN } from "@/lib/data/words";
import { createExerciseStore } from "./create-exercise-store";

export const trainStore = createExerciseStore(
  "train",
  TRAIN,
  z.object({
    selected: z.number(),
    correct: z.boolean(),
    timestamp: z.number(),
  }),
  (attempts) => (attempts[0]?.correct ? 100 : 0),
);
